const footer = {
  footer: {
    imageTitle: 'Enphase Energy の Web サイトを見る',
    privacy: 'プライバシー',
    terms: '条件',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc.無断転載を禁じます。',
    language: '言語'
  }
};

export default footer;
